import React from "react";

import Grid from "@material-ui/core/Grid";
import Features from "./Features";
import Features2 from "./Features2";
import { Typography } from "@material-ui/core";

export default function Main2() {
  return (
    <div style={{ textAlign: "center", margin: "auto 10px auto 10px" }}>
      <Typography variant="h3" style={{ paddingTop: "5%" }}>
        Features
      </Typography>
      <Grid
        item
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{ paddingBottom: "7%" }}
      >
        <Grid item xs={11} sm={3}>
          <Features />
        </Grid>
        <Grid item xs={11} sm={4}>
          <img
            src="image/main.png"
            alt="main"
            height="400px"
            width="200px"
          ></img>
        </Grid>
        <Grid item xs={11} sm={3}>
          <Features2 />
        </Grid>
      </Grid>
      <div id="download"></div>
    </div>
    // <div
    //   id="main2"
    //   className={classes.container}
    //   justify="center"
    //   style={{ maxWidth: "1000px" }}
    // >
    //   <div className={classes.root}>
    //     <Typography variant="h3" style={{ textAlign: "center", padding: "2%" }}>
    //       Features
    //     </Typography>
    //     <Grid
    //       container
    //       direction="row"
    //       spacing={4}
    //       alignItems="center"
    //       justify="center"
    //     >
    //       <Grid item xs={10} sm={4} lg={4}>
    //         <Paper className={classes.paper}>
    //           <Features />
    //         </Paper>
    //       </Grid>
    //       <Grid item xs={10} sm={4} lg={4} justify="center">
    //         <Grid
    //           item
    //           style={{ textAlign: "center" }}
    //           className={classes.imageGrid}
    //         >
    //           <img
    //             alt="main"
    //             src="image/main.png"
    //             className={classes.mainImage}
    //             justify="center"
    //             alignItems="center"
    //           />
    //         </Grid>
    //       </Grid>
    //       <Grid item xs={10} sm={4} lg={4}>
    //         <Paper className={classes.paper}>
    //           <Features2 />
    //         </Paper>
    //       </Grid>
    //     </Grid>
    //   </div>
    // </div>
  );
}
